module.exports = __webpack_public_path__ + "img/danmarcus.737f17ba.png";